export default __webpack_public_path__ + "static/media/add-inactive.b90d8bba.svg";